import { useContext, useState, useEffect } from 'react'
import { PassContext } from "../../../pass-context"
import dataSelector from '../../data-selector'
import PopupEditor from '../../popup-editor'

const GoogleLogo = () => {

  const [imageSrc, setImageSrc] = useState(null)

  const { classData, objectData, instanceData, scannerInstanceData, passType } = useContext(PassContext)

  const sources = getLogoImage({ classData, objectData, instanceData, scannerInstanceData, passType })
  const cardTitle = getCardTitle({ classData, objectData, instanceData, scannerInstanceData, passType })

  useEffect(() => {

    if (sources.wideLogo.value) {
      const img = new Image()
      img.crossOrigin = "anonymous"          // important for canvas/color picking
      img.onload = () => {
        setImageSrc(sources.wideLogo.value)
      }
      img.onerror = () => setImageSrc(null)
      img.src = sources.wideLogo.value                   // set after crossOrigin
    }

    else if (sources.logo.value) {
      const img = new Image()
      img.crossOrigin = "anonymous"          // important for canvas/color picking
      img.onload = () => {
        setImageSrc(sources.logo.value)
      }
      img.onerror = () => setImageSrc(null)
      img.src = sources.logo.value                   // set after crossOrigin
    }

  }, [sources.wideLogo?.value, sources.logo.value])

  if (sources.wideLogo.value) {
    return (
      <>
        <div className="flex flex-row items-center gap-2 basis-full">
          <PopupEditor sources={sources} type="logo" logoType="wideLogo" title="Logo Image">
            <div className="wide-logo-editable editable">
              <img src={imageSrc} className="wide-logo" crossOrigin="anonymous" />
            </div>
          </PopupEditor>
        </div>
        <hr />
      </>
    )
  } else {
    return (
      <>
        <div className="flex flex-row items-center gap-2 basis-full">
          <PopupEditor sources={sources} type="logo" logoType="logo" title="Logo Image">
            <div className="logo-editable editable">
              <img src={imageSrc} className="logo" crossOrigin="anonymous" />
            </div>
          </PopupEditor>

          <PopupEditor title={cardTitle.title} path={cardTitle.path} sources={cardTitle.sources}>
            <div className="logo-text text-nowrap truncate editable">{cardTitle.value}</div>
          </PopupEditor>
        </div>
        <hr />
      </>
    )
  }
}

export default GoogleLogo


const getLogoImage = ({ classData, objectData, instanceData, scannerInstanceData, passType }) => {
  try {

    switch (passType) {
      case "generic":
        {
          const logoUrl = dataSelector({ objectData, instanceData, scannerInstanceData, path: "logo.sourceUri.uri" })
          const wideLogoUrl = dataSelector({ objectData, instanceData, scannerInstanceData, path: "wideLogo.sourceUri.uri" })

          return {
            source: "object",
            logo: {
              path: "logo.sourceUri.uri",
              value: logoUrl ? logoUrl : null
            },
            wideLogo: {
              path: "wideLogo.sourceUri.uri",
              value: wideLogoUrl ? wideLogoUrl : null
            }
          }
        }

      case "flight":
        {
          return {
            source: "class",
            logo: {
              path: "flightHeader.carrier.airlineLogo.sourceUri.uri",
              value: classData.flightHeader.carrier.airlineLogo.sourceUri.uri
            },
            wideLogo: {
              path: "flightHeader.carrier.wideAirlineLogo.sourceUri.uri",
              value: classData.flightHeader ? classData.flightHeader.carrier.wideAirlineLogo.sourceUri.uri : null
            }
          }
        }

      case "transit":
        {
          const logoUrl = objectData.logo ? dataSelector({ objectData, instanceData, scannerInstanceData, path: "logo.sourceUri.uri" }) : classData.logo?.sourceUri.uri
          const wideLogoUrl = objectData.wideLogo ? dataSelector({ objectData, instanceData, scannerInstanceData, path: "wideLogo.sourceUri.uri" }) : classData.wideLogo?.sourceUri.uri

          return {
            source: "class",
            logo: {
              path: "logo.sourceUri.uri",
              value: logoUrl ? logoUrl : null
            }, wideLogo: {
              path: "wideLogo.sourceUri.uri",
              value: wideLogoUrl ? wideLogoUrl : null
            }
          }
        }

      case "eventTicket":
        {
          return {
            source: "class",
            logo: {
              path: "logo.sourceUri.uri",
              value: classData.logo.sourceUri.uri
            },
            wideLogo: {
              path: "wideLogo.sourceUri.uri",
              value: classData.wideLogo ? classData.wideLogo.sourceUri.uri : null
            }
          }
        }

      case "giftCard":
        {
          return {
            source: "class",
            logo: {
              path: "programLogo.sourceUri.uri",
              value: classData.programLogo.sourceUri.uri
            },
            wideLogo: {
              path: "wideProgramLogo.sourceUri.uri",
              value: classData.wideProgramLogo ? classData.wideProgramLogo.sourceUri.uri : null
            }
          }
        }

      case "loyalty":
        {
          return {
            source: "class",
            logo: {
              path: "programLogo.sourceUri.uri",
              value: classData.programLogo.sourceUri.uri
            },
            wideLogo: {
              path: "wideProgramLogo.sourceUri.uri",
              value: classData.wideProgramLogo ? classData.wideProgramLogo.sourceUri.uri : null
            }
          }
        }

      case "offer":
        {
          return {
            source: "class",
            logo: {
              path: "titleImage.sourceUri.uri",
              value: classData.titleImage.sourceUri.uri
            },
            wideLogo: {
              path: "wideTitleImage.sourceUri.uri",
              value: classData.wideTitleImage ? classData.wideTitleImage.sourceUri.uri : null
            }
          }
        }
    }
  }
  catch (err) {
    console.error("Error destructuring logo instanceData, scannerInstanceData, path")
  }
}

const getCardTitle = ({ classData, objectData, instanceData, scannerInstanceData, passType }) => {

  try {
    switch (passType) {
      case "generic":
        {
          return {
            path: "cardTitle.defaultValue.value",
            title: "Card Title",
            sources: ["object"],
            value: dataSelector({ objectData, instanceData, scannerInstanceData, path: "cardTitle.defaultValue.value" })
          }
        }

      case "flight":
      case "eventTicket":
      case "transit":
      case "giftCard":
      case "loyalty":
      case "offer":
        {
          const value = dataSelector({ objectData: classData, instanceData, scannerInstanceData, path: "issuerName" })

          return {
            path: "issuerName",
            title: "Issuer Name",
            sources: ["class"],
            value: value
          }
        }
    }
  }
  catch (err) {
    console.error("Mandatory title missing")
    throw err
  }
}